import Vue from 'vue';

export default Vue.mixin({
  data() {
    return {
      promoDevices: [
        { id: 11, campaign_name: 'Galaxy Z Fold3 5G',  value: 150000 },
        { id: 12, campaign_name: 'Galaxy Z Flip3 5G',  value: 100000 },
      ]
    };
  },
  methods: {
    async callgetCampaignDeviceTypes() {
      const response = await this.$store.dispatch('getCampaignDeviceTypes');
      if (response.status === 200) {
        this.promoDevices = response.data;
      }
    }
  },
})
